import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import workflowRunSourceAdded, {
	type WorkflowRunSourceAddedAction,
} from '@Application/WorkflowRuns/Sources/Actions/workflowRunSourceAdded';
import workflowRunSourceAdditionFailed, {
	type WorkflowRunSourceAdditionFailedAction,
} from '@Application/WorkflowRuns/Sources/Actions/workflowRunSourceAdditionFailed';
import type AddWorkflowRunSource from '@Application/WorkflowRuns/Sources/Commands/AddWorkflowRunSource';
import type { WorkflowRunPayload } from '@Application/WorkflowRuns/WorkflowRun/Actions/workflowRunFetched';
import { post } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = WorkflowRunSourceAddedAction | WorkflowRunSourceAdditionFailedAction;

/** `201` with the whole run, refreshed. */
export default (command: AddWorkflowRunSource) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<WorkflowRunPayload>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/workflow-runs/${command.runId}/sources`,
				command.toJSON(),
			);

			const action = workflowRunSourceAdded(
				payload,
				command.facilityId,
				command.subject.typeKey,
				command.subject.subjectId,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = workflowRunSourceAdditionFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
